<h2 class="title is-3" i18n>Create token scope</h2>

<portal-token-scope-form
  (formValidated)="onFormValidated($event)"
  (canceled)="onCanceled()"
  [disabled]="saving"
></portal-token-scope-form>
